import {Button} from '@material-ui/core';
import React from 'react';
import Modal from 'Shared/components/Modal';
import './UserDetailsModal.sass';

export type UserDetailsModalProps = {
  onClose: () => void;
  firstName: string;
  lastName: string;
  email?: string;
};

const UserDetailsModal = (props: UserDetailsModalProps) => {
  const {onClose} = props;
  return (
    <Modal open onClose={onClose} title="User Details">
      <div className="user-details-modal">
        <div className="user-details-modal__details">
          <h6 className="title">First Name</h6>
          <p>{props.firstName}</p>

          <h6 className="title">Last Name</h6>
          <p>{props.lastName}</p>

          <h6 className="title">Email Address</h6>
          <p>{props.email}</p>
        </div>

        <div className="modal__footer modal__footer-user__details">
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UserDetailsModal;
